module.exports = __webpack_public_path__ + "img/useful-material-container-bg.511dbe9f.jpg";